import React from "react";
import { EllipsisHorizontal } from "react-ionicons";

export const shallowEqual = (object1, object2) => {
	const keys1 = Object.keys(object1);
	const keys2 = Object.keys(object2);

	if (keys1.length !== keys2.length) return false;

	for (let key of keys1) {
		if (object1[key] !== object2[key]) return false;
	}

	return true;
};

export const divisao = (a, b) => {
	if (b === 0) return 0;
	return a / b;
};

export const sanitizeString = (string, manter_espacos = false) => {
	if (!string) return "";
	const regex = manter_espacos ? /[^a-zA-Z0-9\s]/g : /[^a-zA-Z0-9]/g;
	return string.replace(regex, "");
};

export const labelParaName = (str) => {
	if (!str) return "";
	let formatada = str.toLowerCase();
	formatada = formatada.replace(/\s+/g, "_");
	// eslint-disable-next-line no-misleading-character-class
	formatada = formatada.normalize("NFD").replace(/[̀-ͯ]/g, "");
	formatada = formatada.replace(/[^a-z0-9_]+/g, "");
	return formatada;
};

export const obterIniciais = (nome) => {
	if (!nome || typeof nome !== "string" || nome.trim() === "") return "";
	const partes = nome.trim().split(/\s+/);
	if (partes.length === 1) return partes[0].charAt(0).toUpperCase();
	const primeiraInicial = partes[0].charAt(0).toUpperCase();
	const segundaInicial = partes[partes.length - 1].charAt(0).toUpperCase();
	return `${primeiraInicial}${segundaInicial}`;
};

export const primeiraMaiuscula = (str) => {
	if (str.length === 0) return "";
	return str.charAt(0).toUpperCase() + str.slice(1);
};

export const reorder = (list, startIndex, endIndex) => {
	const result = Array.from(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);
	return result;
};

export const tiposArquivos = (type) => {
	const file = { icone: "fa fa-file", tipo: "ARQUIVO" };
	const mimeMap = {
		"application/pdf": { icone: "fa fa-file-pdf", tipo: "PDF" },
		"image/": { icone: "fa fa-image" },
	};

	if (!type) return file;

	for (const key in mimeMap) {
		if (type === key || type.startsWith(key)) {
			file.icone = mimeMap[key].icone;
			file.tipo = mimeMap[key].tipo || type.split("/")[1].toUpperCase();
			break;
		}
	}

	return file;
};

export const tamanhoArquivo = (bytes) => {
	if (!bytes || bytes <= 0) return "0kb";
	if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)}kb`;
	return `${(bytes / (1024 * 1024)).toFixed(1)}mb`;
};

export const renderProgressBar = (valor, base) => {
	let color = "#007E8F";
	let percent = ((valor / base) * 100).toFixed(2);

	if (percent >= 100) {
		color = "#2E7D32";
	} else if (percent < 20) {
		color = "#C62828";
	}

	return (
		<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
			<div style={{ marginRight: "5px", flex: "1" }}>
				<div
					style={{
						backgroundColor: "#ddd",
						borderRadius: "12px",
						height: "4px",
						display: "flex",
						alignItems: "center",
						lineHeight: "8px",
						marginTop: 5,
						marginBottom: 5,
					}}
				>
					<div
						style={{
							width: `${percent}%`,
							height: "100%",
							backgroundColor: color,
							borderRadius: "12px",
							lineHeight: "12px",
						}}
					/>
				</div>
			</div>
		</div>
	);
};

export const renderizarImagens = (users) => {
	const limite = Math.min(users.length, 4);

	return users.slice(0, limite).map((user, index) => {
		const fotoUrl = user.foto?.url;
		const nomeUsuario = user.usr_nome || user.nome || "";
		const temFoto = !!fotoUrl;

		return (
			<div
				key={index}
				style={{ marginLeft: index === 0 ? "" : "-9px" }}
				className={index === 3 ? "reticencias" : ""}
			>
				{temFoto ? (
					<div className="avatar-sm" style={{ backgroundImage: `url(${fotoUrl})` }} />
				) : (
					<p className="inicial" style={{ width: "24px", height: "24px", fontSize: "12px", minWidth: "fit-content" }}>
						{nomeUsuario?.charAt(0) || ""}
					</p>
				)}
				{index === 3 && <EllipsisHorizontal width={"14px"} height={"14px"} />}
			</div>
		);
	});
};

export const createStaticFetchEvent = (localList, filterableFields = []) => {
	if (!Array.isArray(localList)) {
		console.error("createStaticFetchEvent requer um array como primeiro argumento.");
		return () => Promise.resolve({ data: { data: [], total: 0, from: 0, to: 0 } });
	}

	return ({ rows, first, globalFilter, sortField, sortOrder }) => {
		let dataProcessada = [...localList];

		if (globalFilter && filterableFields.length > 0) {
			const termo = globalFilter.toLowerCase().trim();
			dataProcessada = dataProcessada.filter((item) =>
				filterableFields.some((field) => {
					const value = item[field];
					if (value === null || value === undefined) return false;
					return String(value).toLowerCase().includes(termo);
				})
			);
		}

		if (sortField) {
			dataProcessada.sort((a, b) => {
				const aValue = a[sortField];
				const bValue = b[sortField];
				if (aValue === undefined || aValue === null) return sortOrder === 1 ? 1 : -1;
				if (bValue === undefined || bValue === null) return sortOrder === 1 ? -1 : 1;
				if (aValue < bValue) return sortOrder === 1 ? -1 : 1;
				if (aValue > bValue) return sortOrder === 1 ? 1 : -1;
				return 0;
			});
		}

		const total = dataProcessada.length;
		const effectiveRows = rows || 15;
		const startIndex = first || 0;
		const endIndex = Math.min(startIndex + effectiveRows, total);
		const dadosPaginados = dataProcessada.slice(startIndex, endIndex);

		return new Promise((resolve) => {
			setTimeout(() => {
				resolve({
					data: {
						data: {
							data: dadosPaginados,
							total,
							from: startIndex + 1,
							to: endIndex,
						},
					},
				});
			}, 300);
		});
	};
};

export const downloadCSV = (config) => {
	const { data = [], columns = [], filename = "export", separator = ";", lineBreak = "\n" } = config;

	if (!data || data.length === 0) {
		console.warn("Nenhum dado disponível para exportar");
		return;
	}

	if (!columns || columns.length === 0) {
		console.warn("Nenhuma coluna definida para exportar");
		return;
	}

	const header = columns.map((col) => `"${col.header || ""}"`).join(separator);

	const rows = data.map((item) =>
		columns
			.map((col) => {
				let value = "";

				if (col.key) {
					const keys = col.key.split(".");
					value = keys.reduce((obj, key) => obj?.[key], item);
				}

				if (col.formatter && typeof col.formatter === "function") {
					value = col.formatter(value, item);
				}

				if (value === null || value === undefined) value = "";

				value = String(value).replace(/"/g, '""');
				return `"${value}"`;
			})
			.join(separator)
	);

	const csv = [header, ...rows].join(lineBreak);
	const BOM = "﻿";
	const blob = new Blob([BOM + csv], { type: "text/csv;charset=utf-8;" });
	const link = document.createElement("a");
	const url = URL.createObjectURL(blob);

	link.setAttribute("href", url);
	link.setAttribute("download", `${filename}.csv`);
	link.style.visibility = "hidden";

	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);

	URL.revokeObjectURL(url);
};

export * from "./validators";
export * from "./formatters";
